import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from './../../fetch';
import { baseUrl, customHeaders, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';

import { GET_COUPON_PROJECTS, GET_COUPON_PROJECTS_SUCCESS, GET_COUPON_PROJECTS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';

function* getCouponProject({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/admin/projects`,
      method: 'GET',
      headers: {
        Authorization: JSON.parse(window.localStorage.getItem('authUser'))?.token,
        ...customHeaders,
      },
      params: {
        pageIndex: 0,
        pageSize: 100,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COUPON_PROJECTS_SUCCESS,
        payload: response?.data?.results,
      });
    } else {
      yield put({
        type: GET_COUPON_PROJECTS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COUPON_PROJECTS_ERROR, payload: error });
  }
}

export function* watchGetCouponProject() {
  yield takeEvery(GET_COUPON_PROJECTS, getCouponProject);
}

function* getCouponProjectSaga() {
  yield all([fork(watchGetCouponProject)]);
}

export default getCouponProjectSaga;
